<template>
  <div class="blog-initial-layout">
    <h5>Últimas bolsas</h5>
    <div class="row">
      <div
        class="col-lg-4 py-4"
        v-for="(article, index) in lastArticles"
        :key="index"
      >
        <article-link
          :article="article"
          @open-article="$emit('open-article', article)"
        />
      </div>
    </div>
    <h5>Bolsas Graduação</h5>
    <div class="row">
      <div
        class="col-lg-4 py-4"
        v-for="(article, index) in gradArticles"
        :key="index"
      >
        <article-link
          :article="article"
          @open-article="$emit('open-article', article)"
        />
      </div>
    </div>
    <template v-if="masterArticles.length">
      <h5>Bolsas Mestrado</h5>
      <div class="row">
        <div
          class="col-lg-4 py-4"
          v-for="(article, index) in masterArticles"
          :key="index"
        >
          <article-link
            :article="article"
            @open-article="$emit('open-article', article)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ArticleLink from "./ArticleLink";

export default {
  components: { ArticleLink },
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    lastArticles() {
      return this.articles.slice(0, 3);
    },
    gradArticles() {
      return this.articles
        .filter(article =>
          article.level.find(level => level.name === "Graduação")
        )
        .slice(0, 3);
    },
    masterArticles() {
      return this.articles
        .filter(article =>
          article.level.find(level => level.name === "Mestrado")
        )
        .slice(0, 3);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-initial-layout {
  h5 {
    margin-top: 32px;
  }
}
</style>
